export default "__VITE_ASSET__B1klAO5g__"